angular.module('bizmetryApp')
    .controller('ResourceCreateDialogController', function (
        $scope, $q, $mdDialog, $mdToast,
        ResourceService, TemplateInstanceService, DatasourceService, dialogService,
        profile, environments  // ✅ sin resourceTypes ni templateInstance
    ) {
        var vm = this;

        vm.profile = profile;

        // ===== ENVIRONMENTS =====
        vm.environments = (environments || []).map(function (refEnv) {
            return {
                id: refEnv.id,
                name: refEnv.name,
                envType: refEnv.envType || null,
                envTypeId: refEnv.envTypeId || null,
                agentId: refEnv.agent_id || null,
                agentStatus: refEnv.agent_status || null,
                agentLastSyncupTs: refEnv.agent_last_syncup_ts || null,
                templateInstanceId: refEnv.templateInstanceId || null,
                templateInstanceStatus: refEnv.templateInstanceStatus || null,
                templateInstanceVersion: refEnv.templateInstanceVersion || null,
                description: refEnv.description || ''
            };
        });

        // ===== RESOURCE TYPES (dinámico) =====
        vm.resourceTypes = [];
        vm.loadingResourceTypes = true;
        vm.templateInstancesByEnvId = {};  // mapa envId → templateInstance

        // ===== DATASOURCES =====
        vm.datasources = [];
        vm.datasourcesById = {};
        vm.loadingDatasources = true;

        // ===== MODEL =====
        vm.model = {
            resourceName: '',
            resourceDescription: '',
            resourceTypeId: null
        };

        vm.selectedEnvs = {};
        vm.envPkValues = {};
        vm.allSelected = false;
        vm.isSaving = false;
        vm.primaryKeyAttributesCache = {};
        vm.fieldValidationErrors = {};

        // ===== INIT =====
        loadTemplateInstancesAndBuildResourceTypes();
        loadDatasources();

        // ===== CARGAR TEMPLATES =====

        function loadTemplateInstancesAndBuildResourceTypes() {
            vm.loadingResourceTypes = true;

            var eligibleEnvs = vm.environments.filter(function (env) {
                return (env.agentStatus === 'ONLINE' || env.agentStatus === 'STALLED') &&
                    env.templateInstanceStatus === 'PUBLISHED' &&
                    env.templateInstanceId;
            });

            if (eligibleEnvs.length === 0) {
                vm.resourceTypes = [];
                vm.loadingResourceTypes = false;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('No active environments with published templates found')
                        .position('top right')
                        .hideDelay(4000)
                );
                return;
            }

            // Deduplicar templateInstanceIds
            var uniqueTemplateIds = [];
            var seen = {};
            eligibleEnvs.forEach(function (env) {
                if (!seen[env.templateInstanceId]) {
                    seen[env.templateInstanceId] = true;
                    uniqueTemplateIds.push(env.templateInstanceId);
                }
            });

            var fetchPromises = uniqueTemplateIds.map(function (tid) {
                return TemplateInstanceService.getTemplateInstanceById(tid)
                    .then(function (response) { return response.data; })
                    .catch(function (err) {
                        console.error('Error fetching template instance:', tid, err);
                        return null;
                    });
            });

            $q.all(fetchPromises).then(function (results) {
                var loadedTemplates = results.filter(function (ti) { return ti !== null; });

                if (loadedTemplates.length === 0) {
                    vm.resourceTypes = [];
                    vm.loadingResourceTypes = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Could not load template configurations')
                            .position('top right')
                            .hideDelay(4000)
                    );
                    return;
                }

                // Mapa templateId → templateInstance
                var templateById = {};
                loadedTemplates.forEach(function (ti) {
                    templateById[ti.id] = ti;
                });

                // Poblar vm.templateInstancesByEnvId
                vm.templateInstancesByEnvId = {};
                eligibleEnvs.forEach(function (env) {
                    var ti = templateById[env.templateInstanceId];
                    if (ti) {
                        vm.templateInstancesByEnvId[env.id] = ti;
                    }
                });

                // ✅ Construir lista completa: comunes + específicos por ambiente
                vm.resourceTypes = buildAllResourceTypes(loadedTemplates, eligibleEnvs);

                // Preseleccionar el primero si solo hay uno
                if (vm.resourceTypes.length === 1 && !vm.model.resourceTypeId) {
                    vm.model.resourceTypeId = vm.resourceTypes[0].id;
                }

                vm.loadingResourceTypes = false;
                console.log('✅ Resource types loaded:', vm.resourceTypes.length,
                    '(common:', vm.resourceTypes.filter(function (rt) { return rt.isCommon; }).length,
                    ', specific:', vm.resourceTypes.filter(function (rt) { return !rt.isCommon; }).length, ')');
            });
        }

        /**
         * ✅ Construye la lista completa de resource types:
         *    - Los comunes a TODOS los eligible envs  (isCommon: true)
         *    - Los específicos a uno o más envs       (isCommon: false, envIds: [...])
         *
         * Ordenamiento: comunes primero (alphabetical), luego específicos (alphabetical).
         */
        function buildAllResourceTypes(templateInstances, eligibleEnvs) {
            if (!templateInstances || templateInstances.length === 0) { return []; }

            // Mapa templateInstanceId → [envIds] que usan ese template
            var templateToEnvIds = {};
            eligibleEnvs.forEach(function (env) {
                if (!templateToEnvIds[env.templateInstanceId]) {
                    templateToEnvIds[env.templateInstanceId] = [];
                }
                templateToEnvIds[env.templateInstanceId].push(env.id);
            });

            // Agregar todos los resource types encontrados, acumulando sus envIds
            // rtMap: resourceTypeId → { ...rt, envIds: string[], templateVersion: string }
            var rtMap = {};

            // Ordenar templates por version desc para que el más reciente defina el nombre canónico
            var sorted = templateInstances.slice().sort(function (a, b) {
                var vA = a.version || a.templateVersion || '0';
                var vB = b.version || b.templateVersion || '0';
                return vB.localeCompare(vA, undefined, { numeric: true });
            });

            sorted.forEach(function (ti) {
                var envIds = templateToEnvIds[ti.id] || [];
                var rts = extractResourceTypes(ti);
                rts.forEach(function (rt) {
                    if (!rtMap[rt.id]) {
                        // Primera vez que vemos este resource type → usar datos del template más reciente
                        rtMap[rt.id] = angular.extend({}, rt, { envIds: [] });
                    }
                    // Acumular los envIds donde está disponible este resource type
                    envIds.forEach(function (envId) {
                        if (rtMap[rt.id].envIds.indexOf(envId) === -1) {
                            rtMap[rt.id].envIds.push(envId);
                        }
                    });
                });
            });

            // Determinar cuáles son comunes (presentes en TODOS los eligible envs)
            var allEligibleEnvIds = eligibleEnvs.map(function (e) { return e.id; });

            var result = [];
            Object.keys(rtMap).forEach(function (id) {
                var rt = rtMap[id];
                var isCommon = allEligibleEnvIds.every(function (envId) {
                    return rt.envIds.indexOf(envId) !== -1;
                });
                result.push(angular.extend({}, rt, { isCommon: isCommon }));
            });

            // Ordenar: comunes primero (alpha), luego específicos (alpha)
            return result.sort(function (a, b) {
                if (a.isCommon && !b.isCommon) { return -1; }
                if (!a.isCommon && b.isCommon) { return 1; }
                return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
            });
        }

        function extractResourceTypes(templateInstance) {
            try {
                var config = templateInstance.templateConfig;
                if (!config || !config.resource_types) { return []; }
                return config.resource_types.filter(function (rt) {
                    return rt.enabled !== false;
                });
            } catch (e) {
                return [];
            }
        }

        function getTemplateInstanceForResourceType(resourceTypeId) {
            // Primero busca en envs mapeados
            var envIds = Object.keys(vm.templateInstancesByEnvId);
            for (var i = 0; i < envIds.length; i++) {
                var ti = vm.templateInstancesByEnvId[envIds[i]];
                var config = ti && ti.templateConfig;
                if (config && config.resource_types &&
                    config.resource_types.some(function (rt) { return rt.id === resourceTypeId; })) {
                    return ti;
                }
            }
            // Fallback: primer template disponible
            var firstKey = Object.keys(vm.templateInstancesByEnvId)[0];
            return firstKey ? vm.templateInstancesByEnvId[firstKey] : null;
        }

        // ===== HELPERS DE RESOURCE TYPE =====

        /**
         * ✅ Devuelve el nombre de un environment dado su id.
         */
        vm.getEnvNameById = function (envId) {
            var env = vm.environments.find(function (e) { return e.id === envId; });
            return env ? env.name : envId;
        };

        /**
         * ✅ Devuelve el resource type seleccionado actualmente (objeto completo).
         */
        vm.getSelectedResourceType = function () {
            if (!vm.model.resourceTypeId) { return null; }
            return vm.resourceTypes.find(function (rt) { return rt.id === vm.model.resourceTypeId; }) || null;
        };

        /**
         * ✅ Determina si un environment está deshabilitado para el resource type seleccionado.
         *    - Si el RT es común → ningún env está deshabilitado.
         *    - Si el RT es específico → solo los envs en rt.envIds están habilitados.
         */
        vm.isEnvDisabledForResourceType = function (envId) {
            if (!vm.model.resourceTypeId) { return false; }
            var rt = vm.getSelectedResourceType();
            if (!rt || rt.isCommon) { return false; }
            return rt.envIds.indexOf(envId) === -1;
        };

        // ===== DATASOURCES =====

        function loadDatasources() {
            vm.loadingDatasources = true;
            DatasourceService.getDatasources(profile.id)
                .then(function (datasources) {
                    vm.datasources = datasources || [];
                    vm.datasourcesById = {};
                    vm.datasources.forEach(function (ds) {
                        vm.datasourcesById[ds.id] = ds;
                    });
                })
                .catch(function (error) {
                    console.error('❌ Error loading datasources:', error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Warning: Could not load datasource status')
                            .position('top right')
                            .hideDelay(3000)
                    );
                })
                .finally(function () {
                    vm.loadingDatasources = false;
                });
        }

        vm.getDatasourceForMapping = function (envMapping) {
            if (!envMapping || !envMapping.datasource_id) { return null; }
            return vm.datasourcesById[envMapping.datasource_id] || null;
        };

        vm.isDatasourceOnline = function (envId) {
            var envMapping = vm.getEnvMapping(envId);
            if (!envMapping) { return false; }
            var datasource = vm.getDatasourceForMapping(envMapping);
            return datasource ? datasource.isOnline === true : false;
        };

        vm.getDatasourceStatusText = function (envId) {
            if (vm.loadingDatasources) { return 'Loading...'; }
            var envMapping = vm.getEnvMapping(envId);
            if (!envMapping) { return 'No mapping'; }
            var datasource = vm.getDatasourceForMapping(envMapping);
            if (!datasource) { return 'Not found'; }
            return datasource.isOnline ? 'Online' : 'Offline';
        };

        // ===== PRIMARY KEY ATTRIBUTES =====

        vm.getPrimaryKeyAttributes = function (resourceTypeId, envId) {
            if (!resourceTypeId) { return []; }

            var cacheKey = resourceTypeId + (envId ? '_' + envId : '');
            if (vm.primaryKeyAttributesCache[cacheKey]) {
                return vm.primaryKeyAttributesCache[cacheKey];
            }

            var templateInstance = envId
                ? (vm.templateInstancesByEnvId[envId] || getTemplateInstanceForResourceType(resourceTypeId))
                : getTemplateInstanceForResourceType(resourceTypeId);

            if (!templateInstance) { return []; }

            var pkAttributes = [];
            try {
                var templateJson = templateInstance.templateConfig;
                if (templateJson && templateJson.attribute_types && Array.isArray(templateJson.attribute_types)) {
                    pkAttributes = templateJson.attribute_types
                        .filter(function (attr) {
                            return attr.resource_id === resourceTypeId && attr.isPrimaryKey === true;
                        })
                        .map(function (attr) {
                            return {
                                id: attr.id,
                                name: attr.name,
                                column_name: attr.column_metadata_name,
                                column_metadata_name: attr.column_metadata_name,
                                description: attr.description || '',
                                type: attr.scalar_attribute_type || 'STRING',
                                lowerBound: attr.lower_bound,
                                upperBound: attr.upper_bound
                            };
                        });
                }
                vm.primaryKeyAttributesCache[cacheKey] = pkAttributes;
            } catch (error) {
                console.error('Error getting primary key attributes:', error);
            }

            return pkAttributes;
        };

        vm.initializePkValuesForEnv = function (envId) {
            if (!vm.model.resourceTypeId) { return; }
            if (!vm.envPkValues[envId]) { vm.envPkValues[envId] = {}; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, envId);
            pkAttrs.forEach(function (attr) {
                if (vm.envPkValues[envId][attr.id] === undefined) {
                    vm.envPkValues[envId][attr.id] = '';
                }
            });
        };

        vm.clearAllPkValues = function () {
            vm.envPkValues = {};
            vm.primaryKeyAttributesCache = {};
            Object.keys(vm.selectedEnvs).forEach(function (envId) {
                if (vm.selectedEnvs[envId]) {
                    vm.initializePkValuesForEnv(envId);
                }
            });
        };

        vm.areAllPkFieldsFilled = function (envId) {
            if (!vm.model.resourceTypeId || !vm.envPkValues[envId]) { return false; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, envId);
            if (pkAttrs.length === 0) { return true; }
            return pkAttrs.every(function (attr) {
                var value = vm.envPkValues[envId][attr.id];
                return value && value.trim() !== '';
            });
        };

        vm.getFilledPkCount = function (envId) {
            if (!vm.envPkValues[envId]) { return 0; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, envId);
            return pkAttrs.filter(function (attr) {
                var value = vm.envPkValues[envId][attr.id];
                return value && value.trim() !== '';
            }).length;
        };

        vm.buildExternalKeyMappings = function (envId) {
            if (!vm.envPkValues[envId]) { return []; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, envId);
            if (!pkAttrs || pkAttrs.length === 0) { return []; }
            var mappings = [];
            pkAttrs.forEach(function (attr) {
                var value = vm.envPkValues[envId][attr.id];
                if (value && value.trim() !== '') {
                    mappings.push({
                        attributeId: attr.id,
                        attributeName: attr.name,
                        attributeValue: value.trim()
                    });
                }
            });
            return mappings;
        };

        // ===== ENVIRONMENTS =====

        vm.isEnvSelected = function (envId) {
            return vm.selectedEnvs[envId] === true;
        };

        vm.hasSelectedEnvs = function () {
            return Object.keys(vm.selectedEnvs).some(function (key) {
                return vm.selectedEnvs[key] === true;
            });
        };

        vm.onEnvToggle = function (env) {
            if (!vm.selectedEnvs[env.id]) {
                delete vm.envPkValues[env.id];
            } else {
                if (vm.model.resourceTypeId) {
                    vm.initializePkValuesForEnv(env.id);
                }
            }
            updateAllSelectedState();
        };

        vm.toggleSelectAll = function () {
            var newState = vm.allSelected;
            // ✅ Solo afectar environments habilitados para el resource type seleccionado
            vm.environments.forEach(function (env) {
                if (vm.isEnvDisabledForResourceType(env.id)) { return; }
                vm.selectedEnvs[env.id] = newState;
                if (newState) {
                    if (vm.model.resourceTypeId) { vm.initializePkValuesForEnv(env.id); }
                } else {
                    delete vm.envPkValues[env.id];
                }
            });
        };

        function updateAllSelectedState() {
            // ✅ Calcular sobre los environments habilitados únicamente
            var enabledEnvs = vm.environments.filter(function (env) {
                return !vm.isEnvDisabledForResourceType(env.id);
            });
            var totalEnvs = enabledEnvs.length;
            var selectedCount = enabledEnvs.filter(function (env) {
                return vm.selectedEnvs[env.id] === true;
            }).length;
            vm.allSelected = (selectedCount === totalEnvs && totalEnvs > 0);
        }

        $scope.$watch('vm.model.resourceTypeId', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                // ✅ Blanquear siempre toda la selección de environments al cambiar el RT
                vm.selectedEnvs = {};
                vm.envPkValues = {};
                vm.primaryKeyAttributesCache = {};
                vm.allSelected = false;
                updateAllSelectedState();
            }
        });
        // ===== VALIDACIÓN =====

        vm.isFormValid = function () {
            return $scope.resourceForm && $scope.resourceForm.$valid;
        };

        vm.canCreateResource = function () {
            if (vm.loadingResourceTypes) { return false; }
            if (!vm.isFormValid()) { return false; }
            if (!vm.model.resourceTypeId) { return false; }

            var selectedEnvIds = Object.keys(vm.selectedEnvs).filter(function (envId) {
                return vm.selectedEnvs[envId] === true;
            });

            if (selectedEnvIds.length > 0) {
                var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId);

                // ✅ Env seleccionado pero sin PKs definidas → bloquear create
                if (!pkAttrs || pkAttrs.length === 0) { return false; }

                return selectedEnvIds.every(function (envId) {
                    return vm.areAllPkFieldsFilled(envId);
                });
            }

            return true;
        };

        vm.clearValidationError = function (envId, attrId) {
            if (vm.fieldValidationErrors[envId] && vm.fieldValidationErrors[envId][attrId]) {
                delete vm.fieldValidationErrors[envId][attrId];
            }
        };

        vm.clearAllValidationErrors = function () {
            vm.fieldValidationErrors = {};
        };

        vm.hasValidationError = function (envId, attrId) {
            return !!(vm.fieldValidationErrors[envId] && vm.fieldValidationErrors[envId][attrId]);
        };

        vm.getValidationError = function (envId, attrId) {
            return vm.fieldValidationErrors[envId] ? vm.fieldValidationErrors[envId][attrId] : null;
        };

        // ===== HAS / GET ENV MAPPING =====

        vm.hasEnvMapping = function (envId) {
            if (!vm.model.resourceTypeId) { return false; }

            var ti = vm.templateInstancesByEnvId[envId] || getTemplateInstanceForResourceType(vm.model.resourceTypeId);
            if (!ti) { return false; }

            var templateConfig = ti.templateConfig;
            if (!templateConfig || !templateConfig.resource_types) { return false; }

            var resourceType = templateConfig.resource_types.find(function (rt) {
                return rt.id === vm.model.resourceTypeId;
            });

            if (!resourceType || !resourceType.is_resource_imported || !resourceType.env_mappings) { return false; }

            return !!resourceType.env_mappings.find(function (m) {
                return m.env_id === envId && !m.markedForDeletion;
            });
        };

        vm.getEnvMapping = function (envId) {
            if (!vm.model.resourceTypeId) { return null; }

            var ti = vm.templateInstancesByEnvId[envId] || getTemplateInstanceForResourceType(vm.model.resourceTypeId);
            if (!ti) { return null; }

            var templateConfig = ti.templateConfig;
            if (!templateConfig || !templateConfig.resource_types) { return null; }

            var resourceType = templateConfig.resource_types.find(function (rt) {
                return rt.id === vm.model.resourceTypeId;
            });

            if (!resourceType || !resourceType.env_mappings) { return null; }

            return resourceType.env_mappings.find(function (m) {
                return m.env_id === envId && !m.markedForDeletion;
            }) || null;
        };

        function getResourceAttributesForEnv(envId, resourceTypeId) {
            var ti = vm.templateInstancesByEnvId[envId] || getTemplateInstanceForResourceType(resourceTypeId);
            if (!ti) { return []; }

            try {
                var templateJson = ti.templateConfig;
                if (!templateJson || !templateJson.attribute_types) { return []; }

                return templateJson.attribute_types
                    .filter(function (attr) { return attr.resource_id === resourceTypeId; })
                    .map(function (attr) {
                        return {
                            id: attr.id,
                            name: attr.name,
                            column_metadata_name: attr.column_metadata_name,
                            description: attr.description || '',
                            scalar_attribute_type: attr.scalar_attribute_type || 'STRING',
                            isPrimaryKey: attr.isPrimaryKey || false,
                            isResourceNameField: attr.isResourceNameField || false,
                            isResourceDescriptionField: attr.isResourceDescriptionField || false,
                            isSensitive: attr.isSensitive || false,
                            lower_bound: attr.lower_bound,
                            upper_bound: attr.upper_bound,
                            jsonSchema: attr.jsonSchema,
                            jsonSample: attr.jsonSample,
                            resourceNameJsonPath: attr.resourceNameJsonPath,
                            resourceDescriptionJsonPath: attr.resourceDescriptionJsonPath
                        };
                    });
            } catch (error) {
                console.error('Error getting resource attributes:', error);
                return [];
            }
        }

        // ===== CANCELAR =====

        vm.cancel = function () {
            $mdDialog.cancel('user_cancelled');
        };

        // ===== CREAR RECURSO =====

        vm.createNewResource = function () {
            if (vm.isSaving) { return; }

            vm.clearAllValidationErrors();

            if (!vm.canCreateResource()) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Please complete all required fields')
                        .position('top right')
                        .hideDelay(3000)
                );
                return;
            }

            vm.isSaving = true;

            var resourceType = vm.resourceTypes.find(function (t) {
                return t.id === vm.model.resourceTypeId;
            });

            if (!resourceType) {
                vm.isSaving = false;
                dialogService.showErrorDialog('Validation Error', 'Please select a valid resource type.');
                return;
            }

            var isResourceImported = checkIfResourceImported();

            var selectedEnvIds = Object.keys(vm.selectedEnvs).filter(function (envId) {
                return vm.selectedEnvs[envId] === true;
            });

            var needsValidation = isResourceImported && selectedEnvIds.length > 0;

            if (needsValidation) {
                validateRecordsInDatabase(selectedEnvIds)
                    .then(function () {
                        createResource(resourceType);
                    })
                    .catch(function (error) {
                        vm.isSaving = false;
                        showValidationToast(error);
                    });
            } else {
                createResource(resourceType);
            }

            // ===== FUNCIONES INTERNAS =====

            function checkIfResourceImported() {
                try {
                    var ti = getTemplateInstanceForResourceType(vm.model.resourceTypeId);
                    if (!ti) { return false; }
                    var templateConfig = ti.templateConfig;
                    if (!templateConfig || !templateConfig.resource_types) { return false; }
                    var rtConfig = templateConfig.resource_types.find(function (rt) {
                        return rt.id === vm.model.resourceTypeId;
                    });
                    return rtConfig ? rtConfig.is_resource_imported === true : false;
                } catch (error) {
                    return false;
                }
            }

            function validateRecordsInDatabase(envIds) {
                var validationPromises = envIds.map(function (envId) {
                    return validateSingleEnvironment(envId);
                });

                return Promise.all(validationPromises).then(function (results) {
                    var notFound = results.filter(function (r) { return !r.exists && !r.skipped; });

                    if (notFound.length > 0) {
                        notFound.forEach(function (result) {
                            if (!vm.fieldValidationErrors[result.envId]) {
                                vm.fieldValidationErrors[result.envId] = {};
                            }
                            result.pkValues.forEach(function (pkValue) {
                                vm.fieldValidationErrors[result.envId][pkValue.attributeId] =
                                    'Record not found in database';
                            });
                        });

                        $scope.$applyAsync(function () {
                            setTimeout(function () {
                                var firstErrorInput = document.querySelector('.pk-input-validation-error input');
                                if (firstErrorInput) {
                                    firstErrorInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    firstErrorInput.focus();
                                }
                            }, 100);
                        });

                        return Promise.reject({ type: 'RECORDS_NOT_FOUND', notFoundEnvs: notFound });
                    }

                    return Promise.resolve();
                });
            }

            function validateSingleEnvironment(envId) {
                var env = vm.environments.find(function (e) { return e.id === envId; });
                if (!env) {
                    return Promise.resolve({ envId: envId, envName: 'Unknown', exists: true, skipped: true });
                }

                var envMapping = vm.getEnvMapping(envId);
                if (!envMapping) {
                    return Promise.resolve({ envId: envId, envName: env.name, exists: true, skipped: true });
                }

                if (!vm.isDatasourceOnline(envId)) {
                    return Promise.resolve({ envId: envId, envName: env.name, exists: true, skipped: true, reason: 'Datasource offline' });
                }

                var pkAttributes = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, envId);
                if (!pkAttributes || pkAttributes.length === 0) {
                    return Promise.resolve({ envId: envId, envName: env.name, exists: true, skipped: true });
                }

                var pkValues = pkAttributes.map(function (attr) {
                    return {
                        attributeId: attr.id,
                        attributeName: attr.name,
                        attributeValue: vm.envPkValues[envId][attr.id],
                        columnName: attr.column_metadata_name || attr.name
                    };
                });

                var firstPk = pkValues[0];

                return DatasourceService.getTableData(
                    envMapping.datasource_id,
                    envMapping.schema_name,
                    envMapping.table_name,
                    [{ sequence: 1, columnName: firstPk.columnName }],
                    { idColumnName: firstPk.columnName, idValue: firstPk.attributeValue, limit: 1 }
                ).then(function (response) {
                    return {
                        envId: envId,
                        envName: env.name,
                        exists: !!(response && response.rows && response.rows.length > 0),
                        pkValues: pkValues
                    };
                }).catch(function (error) {
                    return {
                        envId: envId,
                        envName: env.name,
                        exists: false,
                        pkValues: pkValues,
                        error: error.data && error.data.message ? error.data.message : 'Validation failed'
                    };
                });
            }

            function showValidationToast(error) {
                if (error.type === 'RECORDS_NOT_FOUND' && error.notFoundEnvs) {
                    var count = error.notFoundEnvs.length;
                    var message = count === 1
                        ? 'Record not found in database. Please verify the primary key values.'
                        : count + ' records not found. Please verify the primary key values.';
                    $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(5000));
                } else {
                    $mdToast.show($mdToast.simple().textContent('Failed to validate records in database').position('top right').hideDelay(5000));
                }
            }

            function createResource(resourceType) {
                var selectedEnvironments = vm.environments.map(function (env) {
                    return {
                        id: env.id,
                        name: env.name,
                        enabled: !!vm.selectedEnvs[env.id],
                        externalKeyMappings: vm.buildExternalKeyMappings(env.id)
                    };
                });

                var dto = {
                    resourceName: (vm.model.resourceName || '').trim(),
                    resourceDescription: (vm.model.resourceDescription || '').trim(),
                    enabled: false,
                    resourceTypeId: vm.model.resourceTypeId,
                    resourceTypeName: resourceType.name || '',
                    resourceType: resourceType,
                    environments: selectedEnvironments,
                    isResourceImported: false
                };

                ResourceService.createResource(profile.id, dto)
                    .then(function (response) {
                        $mdDialog.hide(response.data);
                    })
                    .catch(function (err) {
                        var errorMessage = 'An error occurred while creating the resource.';
                        if (err.data && err.data.message) { errorMessage = err.data.message; }
                        else if (err.data && err.data.error) { errorMessage = err.data.error; }
                        else if (err.statusText) { errorMessage = err.statusText; }
                        dialogService.showErrorDialog('Create Failed', errorMessage);
                    })
                    .finally(function () {
                        vm.isSaving = false;
                    });
            }
        };

        // ===== PICK FROM DATABASE =====

        vm.pickFromDatabase = function (env, $event) {
            if ($event) { $event.stopPropagation(); }

            var envMapping = vm.getEnvMapping(env.id);
            if (!envMapping) {
                dialogService.showErrorDialog('Configuration Error', 'No database mapping found for this environment.');
                return;
            }

            if (!vm.isDatasourceOnline(env.id)) {
                var datasource = vm.getDatasourceForMapping(envMapping);
                var datasourceName = datasource ? datasource.datasourceName : envMapping.datasource_name || 'Unknown';
                dialogService.showErrorDialog('Datasource Offline', 'The datasource "' + datasourceName + '" is currently offline.');
                return;
            }

            var pkAttributes = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, env.id);
            if (!pkAttributes || pkAttributes.length === 0) {
                dialogService.showErrorDialog('Configuration Error', 'No primary key attributes defined for this resource type.');
                return;
            }

            var resourceAttributes = getResourceAttributesForEnv(env.id, vm.model.resourceTypeId);
            if (resourceAttributes.length === 0) {
                dialogService.showErrorDialog('Configuration Error', 'No attributes found for this resource type.');
                return;
            }

            var existingPKsPromise = ResourceService.getResourcePKs(profile.id, env.id, vm.model.resourceTypeId)
                .then(function (response) { return response.data.pks || []; })
                .catch(function () { return []; });

            existingPKsPromise.then(function (existingPKs) {
                $mdDialog.show({
                    controller: 'DatabasePickerDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'profile/tabs/resources/database-picker/database-picker-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true,
                    locals: {
                        envMapping: envMapping,
                        pkAttributes: pkAttributes,
                        environment: env,
                        resourceAttributes: resourceAttributes,
                        maxSelections: 1,
                        existingPKs: existingPKs
                    }
                }).then(function (selectedRecords) {
                    if (!selectedRecords || selectedRecords.length === 0) { return; }

                    var primaryKeys = selectedRecords[0].primaryKeys;

                    if (!vm.envPkValues[env.id]) { vm.initializePkValuesForEnv(env.id); }
                    if (vm.fieldValidationErrors[env.id]) { delete vm.fieldValidationErrors[env.id]; }

                    primaryKeys.forEach(function (pkMapping) {
                        vm.envPkValues[env.id][pkMapping.attributeId] = pkMapping.attributeValue;
                    });

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Primary key values loaded from database')
                            .position('top right')
                            .hideDelay(2000)
                    );
                }).catch(function (error) {
                    if (error !== 'user_cancelled' && error !== 'cancel') {
                        console.error('Error picking from database:', error);
                    }
                });
            });
        };

        // ===== VIEW RECORD DETAILS =====

        vm.viewRecordDetails = function (env, $event) {
            if ($event) { $event.stopPropagation(); }

            if (!env || !vm.isDatasourceOnline(env.id)) {
                $mdToast.show($mdToast.simple().textContent('Datasource is currently offline').position('top right').hideDelay(3000));
                return;
            }

            var envMapping = vm.getEnvMapping(env.id);
            if (!envMapping) {
                $mdToast.show($mdToast.simple().textContent('No column mapping found').position('top right').hideDelay(3000));
                return;
            }

            var pkAttributes = vm.getPrimaryKeyAttributes(vm.model.resourceTypeId, env.id);
            if (!pkAttributes || pkAttributes.length === 0) {
                $mdToast.show($mdToast.simple().textContent('No primary key attributes found').position('top right').hideDelay(3000));
                return;
            }

            var firstPkAttr = pkAttributes[0];
            var pkColumnName = firstPkAttr.column_metadata_name || firstPkAttr.name;
            var pkValue = vm.envPkValues[env.id][firstPkAttr.id];

            if (!pkValue || pkValue.trim() === '') {
                $mdToast.show($mdToast.simple().textContent('Primary key value is empty').position('top right').hideDelay(3000));
                return;
            }

            var resourceAttributes = getResourceAttributesForEnv(env.id, vm.model.resourceTypeId);

            var resourceType = vm.resourceTypes.find(function (t) { return t.id === vm.model.resourceTypeId; });

            var currentResource = {
                resourceName: vm.model.resourceName || 'New Resource',
                resourceTypeId: vm.model.resourceTypeId,
                resourceTypeName: resourceType ? resourceType.name : ''
            };

            var currentResourceType = {
                id: vm.model.resourceTypeId,
                name: resourceType ? resourceType.name : ''
            };

            $mdDialog.show({
                controller: 'ViewRecordDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: 'profile/tabs/resources/view-record/view-record-details-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    environment: env,
                    resource: currentResource,
                    resourceType: currentResourceType,
                    pkAttribute: firstPkAttr,
                    pkColumnName: pkColumnName,
                    pkValue: pkValue,
                    envMapping: envMapping,
                    resourceAttributes: resourceAttributes,
                    templateInstance: vm.templateInstancesByEnvId[env.id] || getTemplateInstanceForResourceType(vm.model.resourceTypeId)
                }
            }).catch(function (error) {
                if (error !== 'user_cancelled' && error !== 'cancel') {
                    console.error('Error opening record details dialog:', error);
                }
            });
        };

    });